import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SortParameter } from '@shared/sort-selector/sort-parameter';

@Component({
  selector: 'mojo-sort-selector',
  templateUrl: './sort-selector.component.html',
  styleUrls: ['./sort-selector.component.scss'],
})
export class SortSelectorComponent {
  @Input() defaultSortParameter: SortParameter;
  @Input() sortParameters: SortParameter[] = [];

  @Output() sortParameterChanged: EventEmitter<SortParameter> = new EventEmitter<SortParameter>();

  areSortParamsEqual(o1: SortParameter, o2: SortParameter): boolean {
    return o1.parameterName === o2.parameterName && o1.dir === o2.dir;
  }
}
